export function fillDataNames(sumupDayData, staffs, locations, products, optionLists, allPayments, categories) {
    // Petit helper pour retrouver une sous-option dans la liste complète des "optionLists".
    // Retourne l'objet subOpt (option elle-même) et le nom du groupe d’options (listName).
    function findOptionInOptionLists(optionId) {
        for (const optionList of optionLists) {
            for (const subOpt of optionList.options) {
                if (subOpt.ref === optionId) {
                    // On a trouvé la sous-option correspondant à 'optionId'
                    return {
                        subOpt,          // { ref, name, ... }
                        listName: optionList.name // ex: "Suppl Alcool" / "Température" etc.
                    };
                }
            }
        }
        return null; // pas trouvé
    }

    // 1) Parcours des staffs
    const staffIds = Object.keys(sumupDayData?.detailbyStaff || {});
    for (let i = 0; i < staffIds.length; i++) {
        const staffId = staffIds[i];
        const staff = staffs.find(x => x.ref === staffId || x.id === staffId);
        if (staff) {
            const staffDetail = sumupDayData.detailbyStaff[staffId];

            // 2) Parcours des locations pour ce staff
            const locationIds = Object.keys(staffDetail.locations);
            locationIds.forEach(locationId => {
                const locationData = staffDetail.locations[locationId];
                const locationObj = locations.find(x => x.ref === locationId || x.id === locationId);
                if (locationObj) {
                    // On renomme la clé locationId => locationObj.name
                    staffDetail.locations[locationObj.name] = locationData;
                    delete staffDetail.locations[locationId];

                    // 3) Parcours des produits/timeSlot dans la location
                    if (locationData.products && locationData.products.timeSlot) {
                        const timeSlotKeys = Object.keys(locationData.products.timeSlot);

                        for (const timeSlot of timeSlotKeys) {
                            const productsInTimeSlot = locationData.products.timeSlot[timeSlot];
                            const productIds = Object.keys(productsInTimeSlot);

                            // 4) Parcours des produits (IDs) dans chaque créneau
                            for (const productId of productIds) {
                                const productDetail = productsInTimeSlot[productId];

                                const productObj = products.find(x => x.ref === productId);



                                if (productObj) {
                                    try {
                                        const categoryObj = categories.find(x => x.ref === productObj.category_id);
                                        if (categoryObj) {
                                            productDetail.categoryName = categoryObj.name;
                                        }
                                    }
                                    catch (e) {
                                        console.error("Error finding category for product:", e);
                                    }

                                    // On renomme la clé productId => productObj.name
                                    productsInTimeSlot[productObj.name] = productDetail;
                                    delete productsInTimeSlot[productId];

                                    // 5) Parcours des options (IDs) dans chaque produit
                                    if (productDetail.options) {
                                        const optionIds = Object.keys(productDetail.options);

                                        for (const optionId of optionIds) {
                                            const optionData = productDetail.options[optionId];
                                            const found = findOptionInOptionLists(optionId);

                                            // found = { subOpt: { ref, name, ... }, listName: "..." } ou null
                                            if (found) {
                                                // On renomme la clé optionId => found.subOpt.name
                                                productDetail.options[found.subOpt.name] = optionData;
                                                // On peut ajouter une propriété optionList (ou optionType) pour mémoriser le groupe
                                                productDetail.options[found.subOpt.name].optionList = found.listName;
                                                // Supprime l’ancienne clé
                                                delete productDetail.options[optionId];
                                            }
                                            // sinon, si non trouvé, on laisse la clé telle quelle, ou vous pouvez faire un autre traitement
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            })

            // Enfin, on renomme la clé staffId => staff.name
            sumupDayData.detailbyStaff[staff.name] = staffDetail;
            delete sumupDayData.detailbyStaff[staffId];
        }

        const paymentTypes = Object.keys(sumupDayData.byPaymentType);
        for (const paymentType of paymentTypes) {
            const paymentObj = allPayments.find(x => x.ref === paymentType);
            if (paymentObj) {
                sumupDayData.byPaymentType[paymentObj.name] = sumupDayData.byPaymentType[paymentType];
                delete sumupDayData.byPaymentType[paymentType];
            }
        }
    }

    return sumupDayData;
}